import { object, string } from "yup";

const validationSchema = object({
  operatorId: string()
    .min(4, "Operator Id must be greater than 4 characters")
    .required("Operator Id is required"),
  password: string()
    .min(6, "Password must be 6 characters long")
    .required("Password is required"),
  email: string()
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "The email id you entered is not valid."
    )
    .required("Email is required"),
  confirmEmail: string()
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "The email id you entered is not valid."
    )
    .required("Confirm Email is required"),
  password7: string()
    .min(7, "Password must be 7 characters long")
    .required("password is required"),
  confirmPassword: string()
    .min(7, "Confirm Password must be 7 characters long")
    .required("Confirm password is required"),

  // Request New Operator
  customUserId: string()
    .min(4, "Operator Id must be greater than 4 characters")
    .required("Operator Id is required"),
  challengeQuestion1: string()
    .min(1)
    .required("Challenge Question 1 is required"),
  challengeQuestion2: string()
    .min(1)
    .required("Challenge Question 2 is required"),
  challengeQuestion1Answer: string()
    .min(1)
    .required("Challenge Question 1 Answer is required"),
  challengeQuestion2Answer: string()
    .min(1)
    .required("Challenge Question 2 Answer is required"),
  challengeQuestion1ConfirmAnswer: string()
    .min(1)
    .required("Challenge Question 1 Confirm Answer is required"),
  challengeQuestion2ConfirmAnswer: string()
    .min(1)
    .required("Challenge Question 2 Confirm Answer is required"),
  firstName: string().min(1).required("First Name is required"),
  lastName: string().min(1).required("Last Name is required"),
  addressLine1: string().min(1).required("Address Line 1 is required"),
  city: string().min(1).required("City is required"),
  zipCode: string()
    .transform((val) => val?.replace("-", "") ?? "")
    .test(
      "len",
      "Zip Code must be either 5 or 9 digits.",
      (val) => val.toString().length === 5 || val.toString().length === 9
    )
    .matches(/^[0-9.()]+$/, "Zip is invalid")
    .required("Zip Code is required"),
  phoneNumber: string()
    .min(10, "Phone Number must be 10 digits")
    .max(10, "Phone Number must be 10 digits")
    .required("Phone Number is required"),
  cellPhoneNumber: string()
    .nullable()
    .notRequired()
    .transform((x) => (x === "" ? undefined : x))
    .min(10, "Cell Phone Number must be 10 digits")
    .max(10, "Cell Phone Number must be 10 digits"),
  faxNumber: string()
    .nullable()
    .notRequired()
    .transform((x) => (x === "" ? undefined : x))
    .min(10, "Fax Number must be 10 digits")
    .max(10, "Fax Number must be 10 digits"),

  // Admin
  internalOperatorId: string()
    .max(8, "Operator Id must be less than 9 characters")
    .required("Operator Id is required"),
  recordkeeperName: string().required("Record Keeper Name is required."),
  recordkeepingName: string().required(
    "Recordkeeping System Name is required."
  ),
  hostPortNumber: string().max(5, "Port is invalid."),
  taxId: string()
    .min(9, "Tax ID must be 9 digits.")
    .max(9, "Tax ID must be 9 digits.")
    .required("Tax ID is required"),
  name: string().required("Name is required"),
  externalId: string().required("External ID is required"),

  // Product Details
  productName: string().required("Product Name cannot be empty"),
  productDesc: string().required("Product Description cannot be empty"),
  description: string().required("Description is required"),
  productType: string().required("Product Type cannot be empty"),
  productDistribution: string().required(
    "Product Distribution cannot be empty"
  ),
  activeDate: string().required("Please select Active Date"),
  closeAt: string().required("Please select Close At Date"),
  reOpenAt: string().required("Please select Re-open At Date"),
  newOwnerShipCloseDate: string().required(
    "Please select New OwnerShip Close Date"
  ),
  newPurchaseCloseDate: string().required(
    "Please select New Purchase Close Date"
  ),
  // Contract And Certificate
  contractNumber: string().required("Contract Number is required"),
  startingCertificateNumber: string()
    .required("Starting Certificate Number is required")
    .max(9, "Certificate Number can be maximum of 9 digits."),
});

const validateForm = async (payload) => {
  const errors = {};

  await validationSchema
    .validate(payload, { abortEarly: false })
    .then(() => {})
    .catch((err) => {
      err.inner.forEach((e) => {
        errors[e.path] = e.message;
        return;
      });
    });

  return errors;
};

export const validate = async (value, field) => {
  let payload = {};
  payload[field] = value;
  const error = await validateForm(payload);
  return error[field];
};
